import React from 'react';
import {
  useLocation,
} from 'react-router';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';

const CardsReceivalWidget: React.FC<WidgetProps> = (props) => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const paramLang = queryParams.get('lang');

  const {
    defaultPaddings,
  } = props;

  return (
    <div
      style={defaultPaddings}
      className={styles.container}
    >
      <div className={styles.cardBody}>
        <h6>
          {paramLang === 'en' ? 'Receive you cards from' : 'استلام بطاقاتك من'}
        </h6>
        <h1>
          {
          paramLang === 'en' ? 'Maadi Branch' : 'فرع المعادي'
          }
        </h1>
      </div>
    </div>
  );
};

export default CardsReceivalWidget;
